

import {AssertUtils,WinUtils,GoingUtils} from "goingutils";

import {
    _dropSingleCommonHtml,
    _dropCommonHtml,
    _showClearIcon
} from "./Common_Fun";
import EditorTypeUtils from "../../../common/editorTypeUtils";

function __ShowWinDropWin(
    {
        winWidth,
        winHeight,
        winTitle,
        pageUrl,
        backFun,
        param = {},
        showBottomBar = false
    },
    vueObj,
    targetObj
) {
    let submitData = targetObj.getSubmitData();
    //弹出顶层窗口
    WinUtils.showInfoOnWin({
        width: winWidth,
        height: winHeight,
        url: pageUrl,
        showBottomBar: showBottomBar,
        params: GoingUtils.mergeJson(param, submitData),
        title: winTitle,
        anim: null
    });
}

let GoLabelCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        return  `<span>${item.content}</span>`;
    },
    //获取显示值
    getShowValue(curVal) {

    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getSingleQueryHtml: function (item, targetObj) {
        return  `<span>${item.content}</span>`;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (item, targetObj) {

    },
    getRealValue(value) {
        return value || " ";
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {

    },
    getQuerySubmitData: function (item, targetObj, backJson) {

    },
    getEditorSubmitData: function (item, targetObj, backJson) {

    },
    clearData(item, formType, targetObj) {

    },
    initWinObject() {
    },
    setValue(prop, propValue, item, targetObj) {

    },
    initCtlEvent: function (

    ) {

    }
};
export default GoLabelCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-label.js